import {
	required,
	minLengthTaxId,
	maxLengthTaxId,
	floatValidation,
	dateValidation,
	minYear,
	applyValidatorsIf,
} from "validators";

export const validateServicesProductsSold = [required];

export const validateFederalTaxID = [required, minLengthTaxId, maxLengthTaxId];

export const validateBusinessStartDate = [
	required,
	dateValidation,
	minYear(1900),
];

const physicalCardValuesEqual100 = (_, allValues) => {
	const { physicalCardPresent, physicalCardNotPresent } = allValues;
	if (!physicalCardPresent && !physicalCardNotPresent) return;
	const sum =
		parseFloat(physicalCardPresent || 0) +
		parseFloat(physicalCardNotPresent || 0);
	return sum !== 100 && "Values must add up to 100%";
};

const physicalCardRequired = (value, allValues) => {
	// prettier-ignore
	const physicalCardPresent =
		Number(allValues?.physicalCardPresent || 0);
	// prettier-ignore
	const physicalCardNotPresent =
		Number(allValues?.physicalCardNotPresent || 0);
	return physicalCardPresent + physicalCardNotPresent < 100;
};

export const validatePhysicalCardPresent = [
	applyValidatorsIf(physicalCardRequired)([required]),
	floatValidation,
	physicalCardValuesEqual100,
];

export const validatePhysicalCardNotPresent = [
	applyValidatorsIf(physicalCardRequired)([required]),
	floatValidation,
	physicalCardValuesEqual100,
];

export const validateMonthlyCreditCardVolume = [required, floatValidation];

export const validateAvgSaleAmount = [required, floatValidation];

export const validateHighestSingleSaleAmount = [required, floatValidation];
